import { render, staticRenderFns } from "./ipob.vue?vue&type=template&id=181ef155&scoped=true&"
import script from "./ipob.vue?vue&type=script&lang=js&"
export * from "./ipob.vue?vue&type=script&lang=js&"
import style0 from "./ipob.vue?vue&type=style&index=0&id=181ef155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ef155",
  null
  
)

export default component.exports